export default "__VITE_ASSET__CfBp5hJT__"